import React from 'react';
import { targetAudienceData } from '../data/mock';
import { CheckCircle, Target } from 'lucide-react';

const TargetAudience = () => {
  return (
    <section id="target-audience" className="py-24 lg:py-32 bg-black relative overflow-hidden">
      <div className="container mx-auto px-6 lg:px-12 relative z-10">
        
        {/* Section Title */}
        <div className="text-center mb-16 lg:mb-20">
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-white mb-6">
            {targetAudienceData.sectionTitle}
          </h2>
          <div className="w-20 h-1 bg-accent-red mx-auto"></div>
        </div>

        {/* Audience Cards */}
        <div className="grid lg:grid-cols-2 gap-8 lg:gap-12 max-w-6xl mx-auto">
          {targetAudienceData.audiences.map((audience) => (
            <div 
              key={audience.id}
              className="bg-gradient-to-br from-gray-900/80 to-black/80 backdrop-blur-sm border border-gold/20 rounded-3xl p-8 lg:p-10 hover:border-gold/40 transition-all group"
            >
              {/* Icon */}
              <div className="w-14 h-14 bg-gold/10 rounded-2xl flex items-center justify-center mb-6 group-hover:bg-gold/20 transition-colors">
                <Target className="text-gold" size={28} />
              </div>

              {/* Title */}
              <h3 className="text-2xl lg:text-3xl font-bold text-white mb-6">
                {audience.type}
              </h3>

              {/* Pain Points */}
              <div className="space-y-4 mb-8">
                {audience.painPoints.map((point, index) => (
                  <div key={index} className="flex items-start gap-3">
                    <div className="mt-1 flex-shrink-0">
                      <div className="w-1.5 h-1.5 rounded-full bg-accent-red"></div>
                    </div>
                    <p className="text-white/70 leading-relaxed text-base">
                      {point}
                    </p>
                  </div>
                ))}
              </div>

              {/* Result */}
              <div className="pt-6 border-t border-gold/10">
                <div className="flex items-start gap-3">
                  <CheckCircle className="text-gold flex-shrink-0 mt-0.5" size={20} />
                  <p className="text-gold font-medium leading-relaxed">
                    {audience.result}
                  </p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default TargetAudience;
